export default "__VITE_ASSET__EXURNaMg__"